import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import ValuesSection from '../components/sections/ValuesSection';
import IntroSection from '../components/sections/IntroSection';
import MarketsSection from '../components/sections/MarketsSection';
import GlobalPresenceSection from '../components/sections/GlobalPresenceSection';
import StatsSection from '../components/sections/StatsSection';
import NewsSection from '../components/sections/NewsSection';
import PartnersSection from '../components/sections/PartnersSection';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ValuesSection />
        <IntroSection />
        <MarketsSection />
        <GlobalPresenceSection />
        <StatsSection />
        <PartnersSection />
        <NewsSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
